import React, { useState, useEffect } from "react";
import styled from "styled-components";

import NoContents from "./NoContents";
import { resetBannerGroupState } from "../../redux/BannerGroupSlice";
import { resetSelectedProducts } from "../../redux/ProductSlice";
import { emptyCategories } from "../../redux/CategorySlice";
import { useDispatch, useSelector } from "react-redux";
import { getCookies, setCookie } from "../../utils";
import { useNavigate } from "react-router-dom";
import { openModal } from "../../redux/ModalSlice";
import { EXPIRE_TRAIL_DUE_DATE, EXPIRE_PAYMENT_OFF_DATE, MODAL_PAYLOAD } from "../../constants";
import moment from "moment/moment";
import { useQuery } from "@tanstack/react-query";
import paymentManager from "../../apis/paymentManager";
import mallManager from "../../apis/mallManager";
import noticeManager from "../../apis/notice";

const Index = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let getPaymentInfo = useSelector( (state)=>{ return state.paymentInfo } );
    const currentDate = moment();
    const isExpireInfoDone = sessionStorage.getItem('isExpireInfoDone');

    const { data: paymentInfo } = useQuery({
        queryKey: ["paymentInfo"],
        queryFn: paymentManager.getPayment,
    });

    const policyModalOpen = async () => {
        const malls = await mallManager.getMallInfo();

        if(malls.data && !malls.data.mall_info?.is_agree) {
            dispatch(
                openModal({
                    ...MODAL_PAYLOAD.POLICY_AGREEMENT,
                })
            );
        } else {
            dispatch(openModal({ ...MODAL_PAYLOAD.NOTICE_DETAIL }));
        }
    }

    useEffect(() => {
        if(getPaymentInfo.mall_id && getPaymentInfo.version === 'Expired' ){
            if(getPaymentInfo.is_first){
                dispatch(openModal({ ...MODAL_PAYLOAD.EXPIRE_TRAIL_WARN }));
                // 팝업 실행
            }  else {
                dispatch(openModal({ ...MODAL_PAYLOAD.EXPIRE_PAYMENT_OFF }));
            }
        }

    }, [getPaymentInfo]);
    useEffect(() => {
        dispatch(resetBannerGroupState());
        dispatch(resetSelectedProducts());
        dispatch(emptyCategories());
        // 앱 정책 동의 공지(일정 기간동안만 유지)
        noticeManager
            .readConfirm({
                id: 7,
            })
            .then();
        // if(!sessionStorage.getItem("notice-popup") || sessionStorage.getItem("notice-popup") !== "read") {
        //     window.open("/policy-notice", "notice", "width=1100px,height=800px,scrollbars=yes");
        // }
        // 약관동의 모달 미노출로 전환
        // policyModalOpen();
    }, []);
    return <NoContents />;
};

export default Index;
